import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, isEqual } from 'lodash';

class MapMarker extends Component {
	shouldComponentUpdate = ({
		$hover, highlightMarker, lat, lng, type, useHover, title, message,
	}) => {
		const lastProps = this.props;

		return (
			$hover !== lastProps.$hover
			|| highlightMarker !== lastProps.highlightMarker
			|| lat !== lastProps.lat
			|| lng !== lastProps.lng
			|| type !== lastProps.type
			|| useHover !== lastProps.useHover
			|| title !== lastProps.title
			|| !isEqual(message, lastProps.message)
		);
	}

	render() {
		const {
			$hover,
			highlightMarker,
			type,
			useHover,
			title,
			message,
		} = this.props;

		return (
			<div className={classNames('map-marker-container', { hovered : $hover, highlightedScale : highlightMarker })}>
				<div className={classNames('map-marker', `${type}-marker`)} />
				<If condition={title || message}>
					<div className={classNames('map-marker-info-box', { hidden : !$hover || !useHover })}>
						<h5 className={classNames({ hidden : isEmpty(title) })}>{ title }</h5>
						{ message }
					</div>
				</If>
			</div>
		);
	}
}

MapMarker.propTypes = {
	$hover          : PropTypes.bool,
	useHover        : PropTypes.bool,
	highlightMarker : PropTypes.bool,
	lat             : PropTypes.number,
	lng             : PropTypes.number,
	type            : PropTypes.string,
	title           : PropTypes.string,
	message         : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element,
	]),
};

MapMarker.defaultProps = {
	$hover          : false,
	useHover        : false,
	highlightMarker : false,
	lat             : undefined,
	lng             : undefined,
	type            : undefined,
	title           : null,
	message         : null,
};

export default MapMarker;
